module.exports = __webpack_public_path__ + "images/6d88f7f656877901534ec9e78243efabc3ce5678592f47dee92849755135fa46.svg";